import { ManufacturerResource } from "../api/barcodeSystem/barcodeManufacturers/get";
import { CreateManufacturerRequest, UpdateManufacturerRequest } from "../api/barcodeSystem/barcodeManufacturers/create";

export class EditBarcodeManufacturerModel {
    isNew: boolean;
    code: string;
    manufacturerName: string;
    suppliesAsn: boolean = false;
    pickingEnabled: boolean = false;
    excludeFromScanningCompliance: boolean = false;
    allowManualStockOrdersCreation: boolean = false;
    suppliesStockAsn: boolean = false;
    visible: boolean = false;
    loading: boolean = true;
    saving: boolean = false;

    get asnType() : string {
        if(this.suppliesAsn)
            return "standard";
        else if(this.suppliesStockAsn)
            return "stock";
        else
            return "none";
    }

    set asnType(val: string) {
        switch(val) {
            case "standard":
                this.suppliesAsn = true;
                this.suppliesStockAsn = false;
                break;
            case "stock":
                this.suppliesAsn = false;
                this.suppliesStockAsn = true;
                break;
            default:
                this.suppliesAsn = false;
                this.suppliesStockAsn = false;
        }
        // only valid alongside stock ASN, so clear it whenever a different option is selected
        if (val !== "stock")
            this.allowManualStockOrdersCreation = false;
    }

    showForNewManufacturer() {
        this.isNew = true;
        this.loading = false;
    }

    showForExistingManufacturer(manufacturer: ManufacturerResource) {
        this.isNew = false;
        this.loading = false;
        this.code = manufacturer.code;
        this.manufacturerName = manufacturer.manufacturerName;
        this.suppliesAsn = manufacturer.suppliesAsn;
        this.suppliesStockAsn = manufacturer.suppliesStockAsn;
        this.pickingEnabled = manufacturer.pickingEnabled;
        this.allowManualStockOrdersCreation = !!manufacturer.allowManualStockOrdersCreation;
    }

    toCreateManufacturerRequest(): CreateManufacturerRequest {
        return {
            code: this.code,
            manufacturerName: this.manufacturerName,
            suppliesAsn: this.suppliesAsn,
            suppliesStockAsn: this.suppliesStockAsn,
            pickingEnabled: this.pickingEnabled,
            excludeFromScanningCompliance: this.excludeFromScanningCompliance,
            allowManualStockOrdersCreation: this.allowManualStockOrdersCreation
        };
    }

    toUpdateManufacturerRequest(): UpdateManufacturerRequest {
        return {
            code: this.code,
            manufacturerName: this.manufacturerName,
            suppliesAsn: this.suppliesAsn,
            suppliesStockAsn: this.suppliesStockAsn,
            pickingEnabled: this.pickingEnabled,
            excludeFromScanningCompliance: this.excludeFromScanningCompliance,
            allowManualStockOrdersCreation: this.allowManualStockOrdersCreation
        };
    }
}
